module.exports = __webpack_public_path__ + "img/CellSystems.75e7dd45.jpeg";